import { useEffect, useState } from 'react';
import { demoRequestHref, heroEntry, navLinks, site } from '@/content/site';
import { AnimatedLogoMark } from './Icons';
import { onWhatsAppAnchorClick } from '@/lib/tracking';
import './Header.css';

type HeaderProps = {
  /** Landing mobile: solo logo + CTA a demo, sin nav ni hamburger. */
  compact?: boolean;
};

export function Header({ compact = false }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const announcement = heroEntry.announcement;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 48);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <>
      {announcement.enabled ? (
        <div className="site-announcement">
          <div className="container site-announcement__inner">
            <a href={announcement.href}>{announcement.text}</a>
          </div>
        </div>
      ) : null}

      <header
        className={`site-header ${scrolled ? 'site-header--scrolled' : 'site-header--entry'}${menuOpen ? ' site-header--menu-open' : ''}`}
      >
        {menuOpen ? (
          <button
            type="button"
            className="site-header__backdrop"
            aria-label="Cerrar menú"
            onClick={() => setMenuOpen(false)}
          />
        ) : null}
        <div className="container site-header__inner">
          <a href="/" className="site-header__brand">
            <AnimatedLogoMark />
            <span>{site.brand}</span>
          </a>

          {compact ? null : (
            <nav className={`site-header__nav ${menuOpen ? 'is-open' : ''}`} aria-label="Principal">
              {navLinks.map((link) => {
                const external = 'external' in link && link.external;
                return (
                  <a
                    key={link.label}
                    href={link.href}
                    className="site-header__nav-link"
                    {...(external
                      ? { target: '_blank', rel: 'noopener noreferrer' }
                      : {})}
                    onClick={(e) => {
                      if (external) {
                        onWhatsAppAnchorClick('header_nav', link.label)(e);
                      }
                      setMenuOpen(false);
                    }}
                  >
                    {link.label}
                  </a>
                );
              })}
            </nav>
          )}

          {compact ? null : (
            <div className="site-header__actions">
              <a
                href={demoRequestHref}
                className="btn btn-secondary btn-secondary--header site-header__cta"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  onWhatsAppAnchorClick('header', heroEntry.ctaPrimary)(e);
                  setMenuOpen(false);
                }}
              >
                {heroEntry.ctaPrimary}
              </a>
            </div>
          )}

          {compact ? null : (
            <button
              type="button"
              className="site-header__menu-btn"
              aria-expanded={menuOpen}
              aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
              onClick={() => setMenuOpen((o) => !o)}
            >
              <span />
              <span />
              <span />
            </button>
          )}
        </div>
      </header>
    </>
  );
}
